"use strict";

require("core-js/modules/es.object.define-property.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  loading: '正在加载中...',
  connecting: '正在连接中...',
  connectError: '连接出错',
  nodata: '暂无数据',
  second: '秒',
  millisecond: '毫秒',
  close: '关闭',
  copy: '复制',
  remoteAssistance: '远程协助',
  fileNameRepetitionExists: '文件名称不能重复',
  menuOperteTip: '* 提示：可通过在各个资源上点击「右键」来进行常用操作',
  uploaderQueueLimit: '只允许同时上传{num}个文件，请等待其中一个正在上传的文件上传完成后再试',
  uploaderFileExist: '该文件正处于上传中，请稍后再试',
  detailError: '当前操作数据异常',
  detailErrorConfirm: '确认关闭',
  batchDeleteTitle: '批量删除',
  deleteMsgTitle: '删除({num})条数据？',
  UnableToRecover: '删除后，数据将无法恢复',
  updateTime: '更新时间',
  repetitionExists: '名称不能重复',
  sameAs: '请保持一致',
  number: '序号',
  tip: '提示',
  createTime: '创建时间',
  ing: '系统正在处理中，请稍等...',
  init: '正在初始化...',
  operation: '操作',
  status: '状态',
  create: '创建',
  download: '导出',
  title: '标题',
  type: '类型',
  sort: '排序',
  edit: '编辑',
  publish: '发布',
  add: '创建',
  "delete": '删除',
  draft: '草稿',
  cancel: '取消',
  back: '返回',
  loginAgain: '重新登录',
  decideGoOut: '确认登出',
  reset: '重置',
  confirm: '确认',
  confirmPws: '请输入管理员密码',
  timestamp: '选择日期时间',
  more: '更多',
  time: '时间',
  select: '请选择',
  input: '请输入',
  describe: '描述',
  name: '名称',
  search: '查询',
  search1: '搜索',
  save: '保存',
  success: '成功',
  atLeastOne: '请至少选择一条数据',
  atMostOne: '最多选择一条数据',
  chooseOne: '请选择一条数据',
  chooseOneActional: '请选择一条可操作数据',
  deleteMsg: '删除后，数据无法恢复',
  pwd: '密码',
  placeholderPws: '请输入密码',
  rj: '锐捷网络',
  nextStep: '下一步',
  preStep: '上一步',
  finish: '结束',
  baseInfo: '基本信息',
  userInfo: '用户信息',
  moreInfo: '更多信息',
  overview: '概览',
  memory: '内存',
  ipAddress: 'IP地址',
  cancelMsg: '已取消',
  deleteUserMsg: '确认删除该用户吗？',
  deletedMsg: '已删除',
  deleteFail: '删除失败',
  totalOverview: '总览',
  passworChange: '修改密码',
  passwordReset: '重置密码',
  passwordResetMsg: '确定要重置成初始密码（123456）吗？',
  resetPwFail: '密码重置失败',
  startTime: '开始时间',
  endTime: '结束时间',
  to: '到',
  upload: '上传',
  uploading: '文件上传中，请耐心等待...',
  actioning: '任务执行中，请耐心等待...',
  roleName: '角色名称',
  refresh: '刷新',
  onlyOneEdit: '只允许对单条数据进行操作',
  operateError: '操作失败',
  rebootCountDown: '系统重启中，请稍等({time}秒)...',
  confirmPre: '请确认要',
  confirmSuf: '，是否继续操作？',
  isAutoFilterMsg: '当前选择的对象中包含不可操作数据，已自动筛选，',
  checkError: '校验异常',
  copySuccess: '复制成功',
  copyError: '复制失败',
  moreOperate: '更多操作',
  searchPlacehold: '请输入关键词',
  getTaskError: '查询任务执行情况失败，请稍后在最近任务中查询',
  specifyIp: '指定网络IP地址',
  specifyIpRange: '指定IP范围',
  distributionIpRange: '分配IP范围',
  navbar: {
    chinese: '简体中文',
    logout: '注销',
    english: 'English',
    screenfull: '',
    user: '',
    language: '',
    welcome: '欢迎您，',
    customerService: '在线客服',
    initialConfig: '配置向导',
    alarm: '告警',
    about: '关于'
  },
  form: {
    common_name: '姓名',
    common_user_name: '用户名',
    common_user_group: '用户组',
    common_terminal_group: '终端组',
    common_phone: '手机号',
    common_email: '邮箱',
    common_term_null_valid: '必填项',
    common_term_length_valid: '长度范围是{min}到{max}位',
    common_global_name_valid: '只能输入字母、数字、汉字、横线以及下划线',
    common_user_email_valid: '邮件已存在',
    common_user_agree_valid: '请同意',
    common_numberValid: '只能输入数字',
    common_emailValid: '请输入正确的邮箱',
    common_name_valid: '只能包含中文、英文，数字，以及"_"，"-"，"@"，"."，且不能以"_"开头',
    softPush_chooseFile_valid: '请选择一个文件',
    softPush_chooseTerminal_valid: '请至少选择一个终端',
    common_term_ip_valid: '请输入正确IP地址',
    common_term_ipRangeCheck_valid: '请在指定IP范围内输入正确的IP地址',
    common_term_ipRange_check: 'IP网段不存在，请重新选择网络'
  },
  serviceError: {
    0: '服务器不可用',
    400: '请求出错',
    401: '未授权，请登录',
    403: '拒绝访问',
    404: '请求地址出错',
    500: '服务器内部错误',
    501: '服务未实现',
    502: '网关错误',
    503: '服务不可用',
    504: '网关超时',
    505: 'HTTP版本不受支持',
    authError: '认证失败，可以取消继续留在该页面，或者重新登录',
    codeError: '你已被登出，可以取消继续留在该页面，或者重新登录',
    timeout: '请求超时'
  },
  about: {
    version: '软件版本号信息',
    bbs: '技术支持论坛',
    hotline: '技术服务热线',
    service: '技术支持',
    supports: '本系统支持浏览器：Chrome(70+)、Firefox(50+)',
    resolution: '默认支持1600*900，推荐使用1920*1080分辨率'
  },
  uploadFile: {
    '-100': '初始化错误',
    // GENERIC_ERROR
    '-200': '上传请求错误',
    // HTTP_ERROR
    '-300': '获取本地文件错误',
    // IO_ERROR
    '-400': '安全错误',
    // SECURITY_ERROR
    '-500': '初始化错误',
    // INIT_ERROR
    '-600': '文件大小错误',
    // FILE_SIZE_ERROR
    '-601': '文件扩展名错误',
    // FILE_EXTENSION_ERROR
    '-602': '已有相同的文件正在上传',
    // FILE_DUPLICATE_ERROR
    '-700': '界面格式化错误',
    // IMAGE_FORMAT_ERROR
    '-701': '内存不足错误',
    // MEMORY_ERROR
    '-702': '超出了处理的上限' // IMAGE_DIMENSIONS_ERROR

  },
  skyLoader: {
    downloadCancel: '取消下载',
    uploadCancel: '取消上传',
    downloadFail: '下载失败，点击删除',
    uploadFail: '上传失败，点击删除',
    retry: '重试',
    stop: '暂停',
    noLoaders: '暂无文件传输中',
    encryption: '正在验证文件完整性...',
    processing: '正在处理中...',
    dataError: '数据异常，请稍后重试',
    downloadFile: '下载文件',
    uploadAgainTips: '请移除文件后，重新点击上传'
  }
};
exports["default"] = _default;